export const contactsData = {
    email: 'akshayredy92@gmail.com',
    phone: '+1 540-558-3991',
    address: 'Charlotte, NC',
    sheetAPI: 'https://sheetdb.io/api/v1/szsz5538aainv'
}